module.exports = __webpack_public_path__ + "img/数据bus标题.cbf92cfb.png";